import { isEmpty } from 'lodash';
import { ReactNode, useEffect, useState } from 'react';
import { FormValidator } from 'src/utils/FormValidator';

export const useFormValidation = (inputparams: any, validator: FormValidator) => {
  const [fieldValidationError, setFieldValidationErrors] = useState<
    Record<string, string>
  >({});
  const [errorALLMessage, setErrorAllMessage] = useState<ReactNode | undefined>();

  useEffect(() => {
    if (
      inputparams &&
      Object.values(fieldValidationError).some((error) => !isEmpty(error))
    ) {
      validate();
    }
  }, [inputparams]);

  const validate = (): boolean => {
    const isValid = validator.validate(inputparams);
    const message = (
      <>
        {Object.values(validator.getErrors()).map((error, index) => (
          <div key={index}>• {error}</div>
        ))}
      </>
    );
    setErrorAllMessage(
      validator.getErrors() && Object.entries(validator.getErrors()).length > 0
        ? message
        : undefined,
    );
    setFieldValidationErrors(validator.getErrors());
    return isValid;
  };

  return {
    validate,
    fieldValidationError,
    setFieldValidationErrors,
    errorALLMessage,
  };
};
